import {Component, EventEmitter, Input, Output} from '@angular/core';

import {Example} from '../../models/example.model';
import {VoiceService} from '../../services/voice/voice.service';
import {GlobalEventService} from '../../services/global-event/global-event.service';

type ExamplePlaySource = Pick<Example, 'id' | 'exampleVoice'>;

@Component({
  selector: 'app-example-play-btn',
  template: `
    <button type="button"
            *ngIf="show"
            class="option-btn type-1"
            [disabled]="disabled"
            [attr.aria-disabled]="disabled"
            [attr.aria-label]="ariaLabel"
            (click)="playSound($event)">
      <i class="ic ic-listen {{ on ? 'on' : '' }}"></i>
    </button>
  `,
  styleUrls: ['./word-play-btn.component.scss'],
  host: { class: 'option-btn' },
})
export class ExamplePlayBtnComponent {
  @Input() example?: ExamplePlaySource | null;
  @Input() showDisabledWhenNoVoice = false;
  @Input() manualPlay = false;
  @Output() play = new EventEmitter<MouseEvent>();

  constructor(
    protected voice: VoiceService,
    protected globalEventSvc: GlobalEventService,
  ) { }

  public playSound($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (!this.example?.id || !this.example?.exampleVoice) {
      console.error('ExamplePlayBtnComponent::playSound() invalid example voice', this.example);
      return;
    }

    if (this.manualPlay) {
      this.play.emit($event);
      return;
    }

    if (this.on) {
      this.voice.Stop();
    }
    else {
      this.voice.PlayExample(this.example.id, this.example.exampleVoice).subscribe({
        error: err => console.error('ExamplePlayBtnComponent::playSound error', err),
      });
      this.play.emit($event);
    }
  }

  public get show(): boolean {
    return !!this.example && (!this.disabled || this.showDisabledWhenNoVoice);
  }

  public get disabled(): boolean {
    return !this.example?.id || !this.example?.exampleVoice;
  }

  public get on(): boolean {
    return this.voice.on && this.voice.exampleId === this.example?.id;
  }

  public get ariaLabel(): string {
    if (this.disabled) {
      return '예문 소리 없음';
    }
    return this.on ? '예문 소리 정지' : '예문 소리 듣기';
  }
}
